import { LinearProgress, Paper, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ProgressCard({
    progress = 0,
    elapsedTime = "0s",
    estimatedTime,
    processedText,
    title,

    dataCy,
}) {
    return (
        <Paper
            data-cy={dataCy}
            variant="outlined"
            sx={{
                p: 2.5,
                borderRadius: 1,
            }}
        >
            <Stack spacing={1.5}>
                <Typography variant="h6">{title}</Typography>

                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack>
                        <Typography variant="h4">{Math.round(progress)}%</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {processedText || "Calculating..."}
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            <Iconify icon="mdi:timer-outline" sx={{ color: "text.secondary", width: 18, height: 18 }} />
                            <Typography variant="body2" color="text.secondary">
                                {elapsedTime || "0s"} elapsed
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={0.5}>
                            <Iconify icon="mdi:clock-outline" sx={{ color: "text.secondary", width: 18, height: 18 }} />
                            <Typography variant="body2" color="text.secondary">
                                {formatTime(estimatedTime)}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>

                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        height: 6,
                        borderRadius: 0.5,
                        bgcolor: "action.hover",
                        "& .MuiLinearProgress-bar": {
                            borderRadius: 0.5,
                        },
                    }}
                />
            </Stack>
        </Paper>
    )
}

function formatTime(estimatedTime) {
    if (!estimatedTime) {
        return "Calculating..."
    }

    return `~${estimatedTime} remaining`
}
